import { h } from "preact";
import { useState } from "preact/hooks";

export function ImageSlider(props: { images: string[], width?: number, height?: number }) {
    const [currentImage, setCurrentImage] = useState(0);

    return <div>
        <img width={props.width} height={props.height} src={props.images[currentImage]}></img>
        <div style="display: flex; justify-content: center; align-items: center; margin-top: 10px;">
            <button type="button" class={currentImage === 0 ? "disabled" : ""} onClick={() => {
                if (currentImage > 0) {
                    setCurrentImage(currentImage - 1);
                }
            }}>Poprzedni</button>
            <button type="button" class={currentImage === props.images.length - 1 ? "disabled" : ""} style="margin-left: 10px" onClick={() => {
                if (currentImage < props.images.length - 1) {
                    setCurrentImage(currentImage + 1);
                }
            }}>Następny</button>
        </div>
    </div>
}